import { Ref } from 'vue-demi';
import { i18n } from '@/i18n';
import { requestExchangeCDK } from '../api/index';
import { showToast } from '@tencent/wphk-components-toast';
import { showDialog, hideDialog } from '@tencent/wphk-components-dialog';
import { useRoute } from '@tencent/wphk-components-hooks';
import { biClick } from '@tencent/fit-bi-sdk';

/**
 *  CDK奖品兑换
 * @param cdkey
 * @param ticket
 * @param goodsInfo
 * @returns
 */
export function useExchange(
  cdkey: Ref<string>, ticket: Ref<string>,
  goodsInfo: Ref<{ id: string, name: string, isDisplayCoupon: boolean }>,
) {
  const { router } = useRoute();

  async function confirmExchange(): Promise<boolean> {
    return new Promise((resolve) => {
      const { name } = goodsInfo.value;
      showDialog({
        content: i18n('您可兌換1張「{{couponName}}」，是否立即兌換？', { couponName: name }),
        btns: [{
          text: i18n('取消'),
          click: () => {
            hideDialog();
            biClick('cdk-exchange.confirm_cancel_click|cdk兑换确认框点击取消兑换');
            resolve(false);
          },
        }, {
          text: i18n('立即兌換'),
          click: () => {
            resolve(true);
            biClick('cdk-exchange.confirm_ok_click|cdk兑换确认框点击立即兑换');
            hideDialog();
          },
        }],
      });
    });
  };

  async function handleExchange() {
    const { id, isDisplayCoupon } = goodsInfo.value;
    await requestExchangeCDK(cdkey.value, ticket.value, id);
    biClick('cdk-exchange.exchange_succ|cdk兑换成功');
    showToast({
      title: i18n('兌換成功'),
      duration: 1000,
    });
    setTimeout(() => {
      router.push({
        name: isDisplayCoupon ? 'displaycouponlist' : 'couponlist',
      });
    }, 1000);
  };

  async function exchangeCDK() {
    const isConfirmed = await confirmExchange();
    if (isConfirmed) {
      await handleExchange();
    };
  };

  return {
    exchangeCDK,
  };
}
